interface StreetSignProps {
  x: number;
  leftCount: number;
  rightCount: number;
}

const StreetSign = ({ x, leftCount, rightCount }: StreetSignProps) => {
  return (
    <div
      className="absolute flex flex-col items-center"
      style={{
        left: `${x}px`,
        top: '50%',
        transform: 'translate(-50%, -50%)',
      }}
    >
      {/* Sign post */}
      <div className="flex flex-col items-center">
        {/* Left arrow sign */}
        <div
          className="bg-green-700 text-white text-xs font-bold px-2 py-1 rounded-sm flex items-center gap-1 shadow-md"
          style={{
            transform: 'skewX(-5deg)',
            borderLeft: '3px solid #15803d',
          }}
        >
          <span>←</span>
          <span>{leftCount} more</span>
        </div>

        {/* Right arrow sign */}
        <div
          className="bg-green-700 text-white text-xs font-bold px-2 py-1 rounded-sm flex items-center gap-1 shadow-md mt-1"
          style={{
            transform: 'skewX(5deg)',
            borderRight: '3px solid #15803d',
          }}
        >
          <span>{rightCount} more</span>
          <span>→</span>
        </div>
      </div>

      {/* Post */}
      <div
        className="bg-gray-600 mt-1"
        style={{
          width: '4px',
          height: '20px',
        }}
      />
    </div>
  );
};

export default StreetSign;
